/**
 * A tenant's term placed inside a sentence ("My coaching", "New site visit"). Terms are labels HR
 * chooses (E9), so lower-casing them whole breaks acronyms and mixed case ("SBI check-in"). Only a
 * plain capitalised word (a capital, then lower-case letters) drops its capital; every other word
 * stays as configured (PR #1314 review P2-6).
 */
export function inSentence(term: string): string {
  return term
    .split(" ")
    .map((word) => (/^[A-Z][a-z'’-]*$/.test(word) ? word.toLowerCase() : word))
    .join(" ");
}
